<mat-accordion class="example-headers-align" multi>
  <mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span></span>
        <span class="text-base sm:text-sm xs:text-xs">{{ 'Search' | translate }}</span>
      </mat-panel-title>
      <mat-panel-description class="flex-row-reverse">
        <span></span>
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 pr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
        </svg>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <div class="p-2">
      <mat-radio-group
        class="flex flex-col md:flex-row justify-center md:justify-around"
        aria-label="Select an option"
        [value]="treatmentType"
        (change)="onTreatmentTypeChange($event.value)">
        <!-- <mat-radio-button class="my-2 pr-2" [value]="TreatmentType.MentalHealth">{{ 'Mental Health' | translate }}</mat-radio-button>
        <mat-radio-button class="my-2 pr-2" [value]="TreatmentType.Prevention">{{ 'Prevention' | translate }}</mat-radio-button>
        <mat-radio-button class="my-2 pr-2" [value]="TreatmentType.SubstanceUse">{{ 'Substance Use' | translate }}</mat-radio-button>
        <mat-radio-button class="my-2 pr-2" [value]="TreatmentType.DropOff">{{ 'Medication Disposal Locations' | translate
          }}</mat-radio-button>
        <mat-radio-button class="my-2 pr-2" [value]="TreatmentType._211Resources">{{ '211 Resources' | translate }}</mat-radio-button> -->
        <mat-radio-button *ngFor="let type of treatmentTypes" class="my-2 pr-2" [value]="type.value">
          {{ type.label | translate }}
        </mat-radio-button>
      </mat-radio-group>
    </div>

    <!-- Services Offered -->
    <mat-form-field *ngIf="shouldShowServicesOffered()" class="p-2 w-full">
      <mat-select placeholder="{{ 'Services Offered' | translate }}" [formControl]="servicesControl" multiple>
        <mat-option *ngFor="let service of serviceList" [value]="service">{{ service.label }}</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Demographics -->
    <mat-form-field *ngIf="shouldShowDemographics()" class="p-2 w-full">
      <mat-select placeholder="{{ 'Demographics' | translate }}" [formControl]="demographicsControl" multiple>
        <mat-option *ngFor="let demographic of demographicList" [value]="demographic">{{ demographic.label }}</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Demographics -->
    <mat-form-field *ngIf="shouldShowPayerSources()" class="p-2 w-full">
      <mat-select placeholder="{{ 'Payer Sources' | translate }}" [formControl]="payerControl" multiple>
        <mat-option *ngFor="let payer of payerSources" [value]="payer">{{ payer.label }}</mat-option>
      </mat-select>
    </mat-form-field>

    <div class="flex flex-wrap flex-row-reverse" *ngIf="shouldShowLocationFilter()">
      <mat-slide-toggle class="flex-none" [(ngModel)]="useDeviceLocation" (change)="onToggleLocation()" [disabled]="disableDeviceLocationToggle">
        {{ 'Use My Current Location' | translate }}
      </mat-slide-toggle>

      <!-- Range -->
      <mat-form-field class="flex-auto flex-grow-0 p-2">
        <mat-label>{{'Range' | translate}}</mat-label>
        <mat-select [(ngModel)]="range" [value]="25">
          <mat-option [value]="25">{{ '25 miles' | translate }}</mat-option>
          <mat-option [value]="50">{{ '50 miles' | translate }}</mat-option>
          <mat-option [value]="100">{{ '100 miles' | translate }}</mat-option>
          <mat-option [value]="150">{{ '150 miles' | translate }}</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Address Input -->
      <mat-form-field *ngIf="!useDeviceLocation" class="flex-grow p-2">
        <mat-label>{{ 'Search By Address' | translate }}</mat-label>
        <input matInput type="text" [(ngModel)]="searchAddress" [disabled]="useDeviceLocation">
        <button *ngIf="searchAddress" matSuffix mat-icon-button aria-label="Clear" (click)="clearAddress()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <mat-action-row>
      <button mat-button (click)="onClearFilters()">{{ 'Clear' | translate }}</button>
      <button mat-button color="primary" (click)="onApplyFilters()">{{ 'Search' | translate }}</button>
    </mat-action-row>
  </mat-expansion-panel>
</mat-accordion>

<!-- <div class="p-2">
  <mat-radio-group class="flex  flex-col md:flex-row justify-center md:justify-around" aria-label="Select an option" name="treatment-type" [(ngModel)]="treatmentType" (change)="radioChange($event)">
    <mat-radio-button class="my-2 pr-2" [value]="TreatmentType.CrisisCenters">{{ 'Crisis Centers' | translate }}</mat-radio-button>
    <mat-radio-button class="my-2 pr-2" [value]="TreatmentType.MentalHealth">{{ 'Mental Health' | translate }}</mat-radio-button>
    <mat-radio-button class="my-2 pr-2" [value]="TreatmentType.Prevention">{{ 'Prevention' | translate }}</mat-radio-button>
    <mat-radio-button class="my-2 pr-2" [value]="TreatmentType.SubstanceUse">{{ 'Substance Use' | translate }}</mat-radio-button>
    <mat-radio-button class="my-2 pr-2" [value]="TreatmentType.DropOff">{{ 'Medication Disposal Locations' | translate
      }}</mat-radio-button>
    <mat-radio-button class="my-2 pr-2" [value]="TreatmentType._211Resources">{{ '211 Resources' | translate }}</mat-radio-button>
  </mat-radio-group>
</div>
<div class="w-full text-center flex sm:text-left">


</div>

<mat-form-field *ngIf="shouldShowServicesOffered()" class="p-2 w-full">
  <mat-select [placeholder]="'Services Offered' | translate" [formControl]="services" [(value)]="selectedServices" multiple>
    <mat-option *ngFor="let service of serviceList" [value]="service">{{service.label}}</mat-option>
  </mat-select>
</mat-form-field>


<mat-form-field *ngIf="shouldShowDemographics()" class="p-2 w-full">
  <mat-select [placeholder]="'Demographics' | translate" [formControl]="demographics" [(value)]="selectedDemographics" multiple>
    <mat-option *ngFor="let demographic of demographicList" [value]="demographic">{{demographic.label}}
    </mat-option>
  </mat-select>
</mat-form-field>

<div class="flex flex-wrap flex-row-reverse">
  <mat-slide-toggle class="flex-none" [(ngModel)]="useDeviceLocation" [disabled]="disableDeviceLocationToggle">{{
    'Use My Current Location' | translate }}</mat-slide-toggle>


  <mat-form-field class="flex-auto flex-grow-0 p-2">
    <mat-label>{{'Range' | translate}}</mat-label>
    <mat-select [(value)]="range">
      <mat-option [value]="25">{{ 'miles' | translate: {number: 25} }}</mat-option>
      <mat-option [value]="50">{{ 'miles' | translate: {number: 50} }}</mat-option>
      <mat-option [value]="100">{{ 'miles' | translate: {number: 100} }}</mat-option>
      <mat-option [value]="150">{{ 'miles' | translate: {number: 150} }}</mat-option>
    </mat-select>
  </mat-form-field>


  <mat-form-field *ngIf="!useDeviceLocation" class="flex-grow p-2">
    <mat-label>{{ 'Search By Address' | translate }}</mat-label>
    <input matInput type="text" [(ngModel)]="searchAddress" [disabled]="useDeviceLocation">
    <button *ngIf="searchAddress" matSuffix mat-icon-button aria-label="Clear" (click)="searchAddress=''">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
</div> -->
